// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e6b38e89","453":"96c6e79f","455":"af51cf0e","977":"560989f4"}[chunkId] + ".chunk.js";
};